/**
 * @module project/components/entry_details/entry_comment_form
 */
import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import { Field } from 'redux-form';
import { ResizableTextAreaField } from 'common/components/form_fields';
import Icon from 'common/components/svg_icon';
import HorizontalSelector from 'common/components/horizontal_selector';

/**
 * Form for adding entry details comment
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class EntryCommentForm extends Component {
  constructor(props) {
    super(props);

    this.state = { internal: props.canSendInternalOnly || false };

    this.sendComment = this.sendComment.bind(this);
    this.getRef = this.getRef.bind(this);
    this.getSelectorOptions = this.getSelectorOptions.bind(this);
    this.getPlaceholder = this.getPlaceholder.bind(this);
  }

  componentDidMount() {
    this.props.methodCallback(
      this.focus.bind(this)
    );
  }

  focus() {
    this.commentInput.focus();
  }

  getRef(element) {
    this.commentInput = element;
  }

  sendComment(data) {
    const { internal } = this.state;
    const {
      revision, entry, commentReply, addComment, addCommentReply, onAddReply,
      reset, canSendInternal, canSendInternalOnly
    } = this.props;
    const formData = {
      body: data.comment,
      internal: false
    };

    if (canSendInternalOnly) {
      formData.internal = true;
    } else if (canSendInternal) {
      formData.internal = internal;
    }

    let ret = null;

    if (commentReply) {
      formData.reply_to = commentReply;
      ret = addCommentReply(entry.entry_type, revision.id, { ...formData }).then(onAddReply);
    } else {
      ret = addComment(entry.entry_type, revision.id, { ...formData });
    }

    return ret.then(() => {
      reset();

      /* scroll to the last comment in case it's not a reply */
      const scrollerEl = document.getElementById("comments_scroller");
      if (scrollerEl && !commentReply) {
        scrollerEl.scrollTop = scrollerEl.scrollHeight;
      }
    });
  }

  getSelectorOptions() {
    const { canSendInternal, canSendInternalOnly } = this.props;
    let options = [];

    if (canSendInternal) {
      options = [{
        label: 'Internal note',
        value: true,
      }];

      if (!canSendInternalOnly) {
        options = [{
          label: 'Private comment',
          value: false
        }, ...options];
      }
    }

    return options;
  }

  getPlaceholder() {
    const { internal } = this.state;
    const { isClient, isCollaborator, commentReply, hasCollaborators } = this.props;

    if (commentReply) {
      return 'Add a reply...';
    }

    if (internal) {
      if (isClient) {
        return `Leave an internal note for yourself${hasCollaborators? ' or collaborators' : ''}...`;
      }

      if (isCollaborator) {
        return 'Leave an internal note for yourself, the client or other collaborators...';
      }

      return 'Leave an internal note...';
    }

    if (isClient || isCollaborator) {
      return 'Leave a private comment for the creative...';
    }

    return 'Leave a private comment...';
  }

  render() {
    const { internal } = this.state;
    const { handleSubmit } = this.props;
    const getRef = this.getRef;
    const selectorOpts = this.getSelectorOptions();

    return (
      <div className={classnames("comment-form", { internal })}>
        <form onSubmit={handleSubmit(this.sendComment)}>
          { selectorOpts.length > 0 &&
          <HorizontalSelector options={selectorOpts} value={internal}
            onSelect={v => this.setState({ internal: v })} /> }

          <Field
            name="comment"
            placeholder={this.getPlaceholder()}
            component={ResizableTextAreaField}
            getRef={getRef}
          />

          <button
            type="submit"
            className="btn btn-icon-only btn-send"
          >
            <Icon className={classnames('svg-icon', 'svg-icon-lg')} icon="send"/>
          </button>
        </form>
      </div>
    );
  }
}

EntryCommentForm.propTypes = {
  revision: PropTypes.object.isRequired,
  entry: PropTypes.object.isRequired,
  commentReply: PropTypes.number,
  onAddReply: PropTypes.func,
  handleSubmit: PropTypes.func,
  addComment: PropTypes.func,
  addCommentReply: PropTypes.func,
  methodCallback: PropTypes.func,
  canSendInternal: PropTypes.bool,
  canSendInternalOnly: PropTypes.bool,
  isClient: PropTypes.bool,
  isCollaborator: PropTypes.bool,
  hasCollaborators: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./project/components/entry_details/entry_comment_form.jsx